<template>
<div class="chapter">
<div class="inner_page">
<h2 class="nobreak" id="pgepubid00002">CHAPTER I</h2>
<p class="pcalibre drop-cap">COLONEL FENCHURCH stood on his own
hearthstone—that is to say, the smoking-room
rug—with his back to the fire, and a cup of tea in his
hand. He was a good-looking dapper little man, with
a neat white moustache, a cheery voice, and an unfailing
flow of talk.</p>
<p class="calibre7">“I say, Doodie,” turning to a lady in a splashed
habit, who was meditatively consuming buttered
toast, “weren’t the roads beastly? Just look at my
boots and leathers!”</p>
<p class="calibre7">Doodie, his wife, nodded, but made no other
reply.</p>
<p class="calibre7">“A clinking run,” he continued, “and a lot of those
thrusters got left—you went well—eh?—that was a
nasty place out of the round plantation!—on the
whole—a good hard day!”</p>
<p class="calibre7">Once more his better-half inclined her hatted head;
evidently her mind was preoccupied. She was staring
fixedly at a certain pattern in the carpet, with a remote
and far-away gaze; a plain weather-beaten lady whose
age—much discussed among her acquaintances—was<span id="pgepubid00003" title="[2]"><a id="Page_2"></a></span>
probably five-and-forty; her habit displayed a slight
square-shouldered figure; a pot hat pushed to the
back of her head disclosed the inevitable red mark,
a long but aristocratic nose, and a clever resolute
countenance.</p>
<p class="calibre7">Dorothy Fenchurch was a notable example of the
strong-willed active woman, mated to a weak, easy-going,
good-tempered man: and the match had proved
a conspicuous success. In the opinion of Tom Fenchurch,
no wife in the County was fit to hold a candle
to his wonderful Dorothy—what a housekeeper, horsewoman,
companion!—and for her part, his Dorothy
was contented. Greedy of influence, social and
domestic, she thoroughly enjoyed the <i class="calibre18">rôle</i> of manager
and mentor. How much more satisfactory to rule in
a small establishment, and over a limited circle, than
to languish at home, the insignificant member of an
important house, who kept their women-folk inflexibly
in the background; and so it came to pass that twelve
years previously, the Honourable Dorothy Claremont
bestowed her hand and her fortune on agreeable
Colonel Fenchurch, who had little to offer her, besides
his handsome face, his retired pay, and his heart.</p>
<p class="calibre7">The couple had settled down in a ramshackle old
house, in a ramshackle old village in the Midlands,
inconveniently remote from the railway, but within
easy reach of the principal Meets of a well-known
sporting pack. The bride’s relations—who had not
favoured the alliance—shrugged their shoulders and
commiserated ‘poor Dorothy.’ They little knew that<span id="pgepubid00004" title="[3]"><a id="Page_3"></a></span>
‘poor Dorothy,’ now thoroughly free and independent,
was as happy as the day was long!</p>
<p class="calibre7">Here, in the sleepy hamlet of Thornby, the Honble.
Mrs. Fenchurch soon made her presence felt. She, so
to speak, ‘took hold’ with both hands; stirred up the
villagers, the parson, and the doctor; improved the old
manor out of all recognition—and that at no great
expense.</p>
<p class="calibre7">This energetic lady had the good fortune to discover
a priceless treasure in the village carpenter, and he and
a journeyman mason, a few odd men, with Mrs. Fenchurch
as architect, threw out a window here, shut up
a door there, and boldly altered the principal staircase.
By and by when visitors arrived to call, and were
beholders of these amazing triumphs, more than
one exclaimed:</p>
<p class="calibre7">“Why on earth did <i class="calibre18">we</i> not think of taking The Holt,
and doing it up? It is perfectly delightful—who
would have guessed at its capabilities?”</p>
<p class="calibre7">But these envious folk never considered that its
present tenant was endowed with an unusual supply
of brains, enterprise, and courage. She was a born
decorator, a skilled upholsteress, and had a positive
genius for gardening. Before long, the attractions of
The Holt were famous within a radius of ten miles—Mrs.
Fenchurch seemed to know exactly where to find
the prettiest chintzes, the most unique furniture, the
newest roses; and her cleverness in picking up prizes in
old curiosity shops had become a proverb. It was
said, that in a back street of the county town she had<span id="pgepubid00005" title="[4]"><a id="Page_4"></a></span>
actually bought a wonderful old Chippendale sideboard
for fifteen shillings—but this would appear to be
incredible.</p>
<p class="calibre7">For twelve years The Holt was acknowledged to be
one of the pleasantest houses in the County, its inmates
the most popular, important, and influential
couple of the neighbourhood, and here Doodie Fenchurch
(with good-natured Tom as her consort) reigned
alone and supreme.</p>
<p class="calibre7">But now a change was imminent; a princess was
about to enter into this kingdom—yes, and to enter
within half an hour. Possibly this was why its mistress
seemed so unusually silent and <i class="calibre18">distrait</i>.</p>
<p class="calibre7">The only sister of Colonel Fenchurch had made a
runaway match with a harum-scarum Irishman, who
was killed in India, leaving his widow almost penniless.
She died soon afterwards, and the unnecessary infant
who ought to have accompanied her mother, survived
to be supported by the Fenchurch family—themselves
uncomfortably impecunious. Now this girl was seventeen,
and in spite of Mrs. Fenchurch’s lamentations,
protestations, and suggestion that she should remain
another year, Letty Glyn had left school, and was on
her way to take up her abode with darling Uncle Tom,
and dearest Aunt Dorothy.</p>
<p class="calibre7">Apparently dearest Aunt Dorothy was not warmly
enthusiastic respecting her niece by marriage; but she
was a woman who sedulously studied appearances.
If Tom’s niece were turned out to earn her bread as
companion or governess, what a talk there would be!<span id="pgepubid00006" title="[5]"><a id="Page_5"></a></span>
There was positively no alternative, the girl must
make her home at The Holt, in the character of <i class="calibre18">le
fâcheux troisième</i>.</p>
<p class="calibre7">As a child, Letty had promised to be rather pretty,
and Mrs. Fenchurch believed that with her own social
advantages, she would marry her off ere long; but
before arriving at this happy period, she resolved to
make the poor relation useful in the house. She should
dust china, arrange flowers, pour out tea, help in the
garden, and take over the Mothers’ Sewing Club. Her
own hands were more than full both at home and
abroad (indeed, the influence of Mrs. Fenchurch now
radiated far and wide), she was secretary here, treasurer
and chairwoman there, and was often sorely
pressed for time. Oh yes, Letty would have her uses;
but all the same a girl in the house—a girl, who was
always <i class="calibre18">en evidence</i>, to whom one must be a sort of
model and sheep dog, would undoubtedly be an
intolerable nuisance.</p>
<p class="calibre7">“I say,” began her husband, breaking in upon her
reflections. She looked up at him quickly. “Isn’t
Letty due about now? Six-thirty?”</p>
<p class="calibre7">“Oh yes, if the train is pretty punctual; but you
know what these cross lines are.”</p>
<p class="calibre7">“Do you think she will be a little hurt at no one
going to meet her—eh?”</p>
<p class="calibre7">“Hurt! My dear boy, what nonsense!”</p>
<p class="calibre7">“Well, of course, hunting is hunting, and Garfield
Cross is our best meet. By the way, I suppose you sent
the brougham? It’s an uncommonly cold, raw night.”</p>
<p class="calibre7"><span id="pgepubid00007" title="[6]"><a id="Page_6"></a></span>“The brougham? Certainly not! I sent the
governess-car—yes,” in answer to his exclamation.
“You see, dear, Collins has had three horses to do up—you
know you had out two—you extravagant man,
and I really couldn’t ask him to leave them all to
James, so the boy took the car with the garden pony,
and her luggage will come up to-morrow by the
market-cart.”</p>
<p class="calibre7">“I say, old girl,” suddenly putting down his cup
and going over to her, “it’s not a very warm reception,
eh? The child has not been near us this five years—and
it’s a long journey from Dresden, eh?” Then, in
another and more caressing tone, he added, “You <i class="calibre18">will</i>
be good to her, Doodie darling, won’t you? You can
make it so awfully nice, if you like to, you know!”</p>
<p class="calibre7">“Am I not always what you call ‘good’ to my
guests?” she demanded rather sharply.</p>
<p class="calibre7">“Oh, hang it all, Doodie, but <i class="calibre18">she</i> won’t be a guest!
Letty is one of us, eh—isn’t she, old woman? Of
course, I know it’s hard on you, and she has only her
little bit of a pension; but a girl in the house will be
cheery, eh? And you’ll take to her, I know,” and he
put his arm round her neck, and gazed into her shrewd,
thin face, and repeated, “Eh, darling, won’t you?”</p>
<p class="calibre7">Just at this moment the door opened, and a formal
voice announced ‘Mrs. Hesketh.’</p>
<p class="calibre7">Mrs. Hesketh, a middle-aged lady with a stately
carriage and the remains of great beauty, entered just
in time to witness the caressing attitude of Colonel
Fenchurch.</p>
<p class="calibre7"><span id="pgepubid00008" title="[7]"><a id="Page_7"></a></span>“We have had a row, you see!” he explained to
the visitor with the gaiety of a schoolboy; “the old
woman and I have had a shake-up, and been making it
up—she <i class="calibre18">will</i> pound me out hunting. I call it deuced
bad form, eh?”</p>
<p class="calibre7">Mrs. Hesketh, a widowed cousin who lived in the
only other ‘house’ in the village, carefully removed
her heavy sables before she replied.</p>
<p class="calibre7">“I should think, Tom, that you are used to that by
this time. Had you had a good day?”</p>
<p class="calibre7">“Ripping!”</p>
<p class="calibre7">“Many out?”</p>
<p class="calibre7">“Oh, the usual lot, and Hugo Blagdon. By Jove!
he does have wonderful cattle. I hear he pays as much
as five hundred for a hunter. Yes, and he can ride
them too,” he added with unusual generosity.</p>
<p class="calibre7">“But what brings him over to this side?” enquired
Mrs. Hesketh with languid curiosity.</p>
<p class="calibre7">“He’s only staying at the ‘Black Cock’ at Ridgefield
for a week or so—it’s more central than Sharsley.
Sharsley is a good bit out of the way for everything;
seven miles from a railway station—monstrous, isn’t
it in these days?”</p>
<p class="calibre7">“Yes, but we need not boast. Sharsley is a lovely
old place; I shouldn’t mind living there myself!”</p>
<p class="calibre7">“No,” he answered with a laugh; “and a heap of
other ladies will say ditto to Mrs. Hesketh, eh, Doodie?”
appealing to his wife.</p>
<p class="calibre7">“I can’t think what’s keeping her,” was the irrelevant
reply.</p>
<p class="calibre7"><span id="pgepubid00009" title="[8]"><a id="Page_8"></a></span>Mrs. Hesketh stared at her cousin with grave-eyed
interrogation.</p>
<p class="calibre7">“Oh, I mean Letty Glyn, Tom’s niece, you know,
Maudie. Didn’t I tell you that we expect her this
evening, by the two o’clock from St. Pancras?”</p>
<p class="calibre7">“So you did; and she is coming to stay for some time?”</p>
<p class="calibre7">“To live with us altogether,” eagerly amended
Colonel Fenchurch. “She is an orphan, the daughter
of my poor sister Kathleen.”</p>
<p class="calibre7">Mrs. Hesketh glanced from him to his wife, but Mrs.
Fenchurch’s expression was blank and noncommittal;
she rose, walked to the fire, and brushed the crumbs
from her habit into the fender.</p>
<p class="calibre7">“We are her only relations,” continued Colonel Fenchurch.</p>
<p class="calibre7">“Except her father’s people, who are paupers,”
corrected a thin, high-pitched treble from the fire-place.
“Irish paupers—with nothing to live on but family
pride.”</p>
<p class="calibre7">“If she is like my poor sister, she ought to be a
beauty,” urged her uncle, and his tone was anxious
and conciliatory.</p>
<p class="calibre7">“She was some way from <i class="calibre18">that</i> when we last saw
her,” declared his wife, turning to face them; “a
long-legged creature, with a pair of sunken eyes and
quantities of tousled hair. Of course, she may have
improved,” she added tolerantly; “and,” with a
glance at her husband’s chiselled profile, “I hope she
will take after the Fenchurch family. A girl with a
pretty face does get such a splendid start.”</p>
<p class="calibre7"><span id="pgepubid00010" title="[9]"><a id="Page_9"></a></span>“She does,” agreed Mrs. Hesketh, whose own beautiful
face had been her fortune; “but if she hasn’t
something to back it up in the way of character, or
brains, or charm,—it’s not so much of a start, after all.”</p>
<p class="calibre7">“Hullo—wheels!” announced Colonel Fenchurch.
“Here she is!” and he dashed into the hall.</p>
<p class="calibre7">“I think I ought to go,” murmured the visitor,
reaching for her boa; “this is a family affair,” she
added with a smile.</p>
<p class="calibre7">“And you are one of the family, Maudie,” declared
Mrs. Fenchurch, laying a strong detaining hand upon
her arm; “so you must stay.” Then, removing her
hat, which she tossed on the sofa, she was about to
follow her husband, when the door was thrown wide,
and Colonel Fenchurch advanced into the room, beaming
with pride, and leading a tall girl in a fur-lined
cloak, who looked both timid and tired.</p>
<p class="calibre7">“My dear Letty, how late you are!” exclaimed her
aunt, taking both her hands in hers and pecking her
on the cheek; “and how frozen!”</p>
<p class="calibre7">“There was a slight accident which delayed us,”
explained the girl nervously.</p>
<p class="calibre7">“Now, then, give me your cloak, and have some
tea, and tell us all about it,” said her uncle, fussing
round her.</p>
<p class="calibre7">“I am afraid the tea is rather cold,” said Mrs. Fenchurch,
moving towards the tea equipage; “but we
will have some more at once,” and she rang the bell
violently.</p>
<p class="calibre7">“Maudie, this is my niece Lettice,” said Colonel<span id="pgepubid00011" title="[10]"><a id="Page_10"></a></span>
Fenchurch, presenting her with ceremony. “Letty,
Mrs. Hesketh is our nearest neighbour and your
aunt’s cousin, and I hope you may find a corner in
her heart.”</p>
<p class="calibre7">“My dear, you must be perished,” said the lady
kindly. “Why, I declare you are positively shivering!”</p>
<p class="calibre7">“Oh no, no,” she protested, whilst her uncle helped
her to remove her wrap. “This room is delightfully
warm.”</p>
<p class="calibre7">“Now, Letty, take off your hat,” he urged eagerly.</p>
<p class="calibre7">“I am afraid my hair is dreadfully untidy,” but she
nevertheless removed a fur cap, and bared a head of
beautiful light brown hair, which exhibited a natural
wave.</p>
<p class="calibre7">“So you have had a long journey,” continued Mrs.
Hesketh.</p>
<p class="calibre7">“Yes, nearly two days—we all travelled together—I
mean the girls at my school—as far as London.”</p>
<p class="calibre7">“And the crossing?”</p>
<p class="calibre7">“Oh,” with a quick, expressive gesture, “<i class="calibre18">dreadful</i>!
I’d rather not think of it! Sometimes the boat stood
upright!”</p>
<p class="calibre7">“Come tell us about your railway accident,” said
her uncle cheerfully.</p>
<p class="calibre7">“It was really nothing,” she answered; “we ran
past another train that had been shunted, and the end
of it caught our carriage doors, or something—at any
rate we were nearly shaken off the line. It gave us a
shock, for we were travelling fast, and were dreadfully
mixed up in our compartment.”</p>
<p class="calibre7"><span id="pgepubid00012" title="[11]"><a id="Page_11"></a></span>“And who were you mixed up with?” he enquired
jocosely.</p>
<p class="calibre7">“The young man in the opposite seat,” and she
coloured and laughed. “He wore an enormously
thick ulster, and so I wasn’t a bit hurt.”</p>
<p class="calibre7">“And afterwards?”</p>
<p class="calibre7">“We had all to get out and wait at a tiny station
for more than an hour—such a bare miserable——”</p>
<p class="calibre7">“Do you take sugar?” interrupted Mrs. Fenchurch,
with the tongs in her hand.</p>
<p class="calibre7">“Yes, if you please, aunt—one lump.”</p>
<p class="calibre7">“Then here is your tea at last, and some nice hot
toast,” said Colonel Fenchurch, approaching. As he
sat down beside her he said, “And how did you and
the young man continue the acquaintance so violently
begun?”</p>
<p class="calibre7">“He asked me if I was hurt—that was all.”</p>
<p class="calibre7">“The least he could do! Why, bless my soul, he
might have knocked all your front teeth down your
throat, or put out one of your eyes—and then he would
have had to marry you, eh?”</p>
<p class="calibre7">“I am sure he wouldn’t have agreed to that,” she
answered gaily.</p>
<p class="calibre7">“He might go further, and fare worse,” rejoined her
uncle, with a proud and significant glance at his wife,
who had now approached the sofa.</p>
<p class="calibre7">“Of course, you left your luggage at Tatton, Letty?”</p>
<p class="calibre7">“Yes, Aunt Dorothy; I only brought up my dressing-bag.
The boy gave me your message.”</p>
<p class="calibre7">“That was right. And now, as soon as you feel a<span id="pgepubid00013" title="[12]"><a id="Page_12"></a></span>
little rested, I will take you upstairs. Your quarters
are at the top of the house, but large and sunny—with
a funny little staircase all to yourself!”</p>
<p class="calibre7">“I am sure it is charming, aunt,” rising as she spoke;
“it will be delightful to have not only a staircase, but a
whole room to myself,” and with a pretty little foreign
curtsey to Mrs. Hesketh, the girl collected her wraps
and followed Mrs. Fenchurch into the hall.</p>
<p class="calibre7">“Well, what do you think of her, eh?” enquired
Colonel Fenchurch, retiring to the hearth-rug as to a
vantage ground, and sticking his thumbs into the arm-holes
of his waistcoat.</p>
<p class="calibre7">“She is <i class="calibre18">lovely</i>,” replied his companion, after a
moment’s deliberation. “When one sees a girl so
fresh, so exquisite, and so unconscious, one cannot
help thinking of the quotation, ‘What of the lovers in
the hidden years?’”</p>
<p class="calibre7">“Lovers be hanged!” he exclaimed irritably.
“Letty is too young yet—we shall keep her with
us as long as we can. She seems as simple as a child,
doesn’t she?—and rather shy?”</p>
<p class="calibre7">“I fancy she is one of those girls who develop slowly.
Her age may be seventeen, but in experience of life
probably she is not more than ten or twelve.”</p>
<p class="calibre7">“Lots of girls know their way about the world at
seventeen, and are one too many for many a man,” declared
Colonel Fenchurch; “but I remember that my
sister, ten years my junior, was extraordinarily young
in her ideas, easily influenced, ready to be ordered
about, and as obedient as if she were a kid. She never<span id="pgepubid00014" title="[13]"><a id="Page_13"></a></span>
knew her own mind—or had any fixed opinions—except
about Glyn. He made up her mind, and ordered
her to run away with him, a handsome, reckless, dare-devil.
They went out to India to his regiment, and he
was killed within a year up on the frontier, some fool-hardy
exploit, or he would be alive now.”</p>
<p class="calibre7">“And take his daughter off your hands,” suggested
the lady.</p>
<p class="calibre7">“Oh, well, I am happy and proud to adopt
his daughter—especially since I have none of my
own.”</p>
<p class="calibre7">He paused, and stared down into the fire; his companion
well knew that this was the one grief of his
married life. Tom loved children, and was ever the
most popular and entertaining guest at their dances
and amusements; he longed to hear the patter of
quick little feet up and down The Holt’s uneven
passages. Doodie, his wife, had never shared this
craving—the whole County was, so to speak, <i class="calibre18">her</i>
child. Possibly she would not have objected to a fine
clever boy, who excelled at games and was a brilliant
success as a prize-winner, but a large family of daughters—no,
thank you! Her husband, on the contrary,
had a particular partiality for girls. Often, as he smoked
a solitary pipe in the fire-light, with half-closed eyes,
he seemed to see a golden-haired darling, the daughter
of his dreams, sitting on the hearth-rug, or standing by
the window. And here to-day, had actually come to
him, the realisation of his visions!</p>
<p class="calibre7">“I do hope—I do hope——” he began, then hesitated.</p>
<p class="calibre7"><span id="pgepubid00015" title="[14]"><a id="Page_14"></a></span>Mrs. Hesketh raised her dark discontented eyes to
his, and murmured an interrogative “Yes?”</p>
<p class="calibre7">After a momentary struggle between inclination
and discretion, he continued, “Between you and me,
Maudie,” lowering his voice to a whisper, “I hope to
goodness that Doodie will take to her!”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?68655b1c